import { render, staticRenderFns } from "./MedicineMngt.vue?vue&type=template&id=5bf7d6ff"
import script from "./MedicineMngt.vue?vue&type=script&lang=js"
export * from "./MedicineMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports